import { APP_URL, URL_NAME } from '../utils/constants';
import React from 'react';
import PageWrapper from '../components/PageWrapper';
import { Stack, Text } from '@chakra-ui/react';

const PrivacyPolicy = () => {
  return (
    <PageWrapper>
      <div>
        <div style={{ padding: 20 }}>
          <Text fontSize="3xl" fontWeight="bold">
            privacy policy
          </Text>
          <Stack spacing={4} mt={4}>
            <Text>
              Your privacy is important to us. It is {URL_NAME}'s policy to
              respect your privacy regarding any information we may collect from
              you across our website, <a href={APP_URL}>{URL_NAME}</a>, and
              other sites we own and operate.
            </Text>
            <Text>
              We only ask for personal information when we truly need it to
              provide a service to you. We collect it by fair and lawful means,
              with your knowledge and consent. We also let you know why we’re
              collecting it and how it will be used.
            </Text>
            <Text>
              We only retain collected information for as long as necessary to
              provide you with your requested service. What data we store, we’ll
              protect within commercially acceptable means to prevent loss and
              theft, as well as unauthorised access, disclosure, copying, use or
              modification.
            </Text>
            <Text>
              We don’t share any personally identifying information publicly or
              with third-parties, except when required to by law.
            </Text>
            <Text>
              Our website may link to external sites that are not operated by
              us. Please be aware that we have no control over the content and
              practices of these sites, and cannot accept responsibility or
              liability for their respective privacy policies.
            </Text>
            <Text>
              You are free to refuse our request for your personal information,
              with the understanding that we may be unable to provide you with
              some of your desired services.
            </Text>
            <Text>
              Your continued use of our website will be regarded as acceptance
              of our practices around privacy and personal information. If you
              have any questions about how we handle user data and personal
              information, feel free to contact us.
            </Text>
            <Text>This policy is effective as of 2 September 2019.</Text>
          </Stack>
        </div>
      </div>
    </PageWrapper>
  );
};

export default PrivacyPolicy;
